<template>
  <div :class="{'mb-4': showInformation || showGeneralInformation}">
    <div class="card text-left">
      <div class="card-body py-3">

        <contact-information v-if="isLoaded && showGeneralInformation"
          :item="item"
          :scope="scope"
          class='mb-3'
        />

        <contact-details v-if="isLoaded"
          :canEdit="canEdit"
          :item="item"
          :user="user"
          :scope="scope"
          :contacts="contacts"
        />

        <spinner v-if="!isLoaded" :containerClass="`width--50px min-height--150px`" />
      </div>
    </div>
  </div>
</template>

<script>
import ContactDetails from '@/components/contact/Details'
import ContactInformation from '@/components/contact/Information'
import Spinner from '@/components/shared/Spinner'

export default {
  name: 'contactShow',
  components: {
    ContactDetails,
    ContactInformation,
    Spinner
  },
  props: {
    isLoaded: {
      type: Boolean,
      required: false
    },
    canEdit: {
      type: Boolean,
      required: false
    },
    scope: {
      type: String,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: false
    },
    contacts: {
      type: Array,
      required: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    showInformation () {
      return !!(this.item.foundation_year || this.item.street || this.item.city || this.item.post_code || this.item.country || this.item.website || this.canEdit)
    },
    showGeneralInformation () {
      return !!(this.item.foundation_year || this.item.street || this.item.city || this.item.post_code || this.item.country || this.item.website)
    }
  }
}
</script>
